import { onMount, type ParentComponent } from "solid-js";
import Header from "./Header";
import Footer from "./Footer";
import RouteTransition from "./RouteTransition";
import { refreshCurrentUser } from "../lib/auth";

const AppShell: ParentComponent = (props) => {
  // Hydrate the current user from a stored token (if any) on first load.
  onMount(() => {
    void refreshCurrentUser();
  });

  return (
    <div class="flex min-h-screen min-h-dvh flex-col bg-background text-foreground">
      <Header />
      <main class="flex-1 pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0">
        <RouteTransition>{props.children}</RouteTransition>
      </main>
      <Footer />
    </div>
  );
};

export default AppShell;
